export function partialBuildLabel(set:{progress:unknown},savedCount:number):string {
 const target=(set.progress as {target?:number}|null)?.target;
 return Number.isSafeInteger(target) && target!>savedCount
  ? `Build ${savedCount} saved concept${savedCount===1?'':'s'} (of ${target} requested)`
  : 'Build Campaign';
}

export function savedAngleSetLabel(set:{status:string;angleCount:number;progress?:unknown}):string {
 const progress=set.progress as {target?:number;kept?:number;missing?:number}|null;
 const incomplete=set.status==='partial'||(Number.isSafeInteger(progress?.missing)&&progress!.missing!>0)
  ||(Number.isSafeInteger(progress?.kept)&&Number.isSafeInteger(progress?.target)&&progress!.kept!<progress!.target!);
 const count=`${set.angleCount} concept${set.angleCount===1?'':'s'}`;
 return incomplete
  ? Number.isSafeInteger(progress?.target)&&progress!.target!>set.angleCount
    ? `Incomplete · ${set.angleCount} of ${progress!.target} concepts saved`
    : `Incomplete · ${count} saved`
  : count;
}
